import React, { useEffect } from 'react';
import Lenis from 'lenis';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const SmoothScroll = ({ children }) => {
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.2,
      easing: (time) => Math.min(1, 1.001 - Math.pow(2, -10 * time)),
      direction: 'vertical',
      gestureDirection: 'vertical',
      smooth: true,
      mouseMultiplier: 1,
      smoothTouch: false,
      touchMultiplier: 2
    });

    const handleScroll = () => {
      ScrollTrigger.update();
    };

    const handleTicker = (time) => {
      lenis.raf(time * 1000);
    };

    lenis.on('scroll', handleScroll);
    gsap.ticker.add(handleTicker);
    gsap.ticker.lagSmoothing(0);

    return () => {
      lenis.off('scroll', handleScroll);
      gsap.ticker.remove(handleTicker);
      lenis.destroy();
    };
  }, []);

  return <div className="smooth-scroll-wrapper">{children}</div>;
};

export default SmoothScroll;